import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject } from 'rxjs';
import { distinctUntilChanged, takeUntil } from 'rxjs/operators';
import { StepService } from '../stepper/step.service';
import { AddPassengerFormComponent } from '../steps/add-passenger-form/add-passenger-form.component';
import { AddPassengerComponent } from '../steps/add-passenger/add-passenger.component';
import { ChoosePolicyComponent } from '../steps/choose-policy/choose-policy.component';
import { ContactInfoComponent } from '../steps/contact-info/contact-info.component';
import { FilledInfoComponent } from '../steps/filled-info/filled-info.component';
import { InsuranceDaysComponent } from '../steps/insurance-days/insurance-days.component';
import { InsuranceTypeComponent } from '../steps/insurance-type/insurance-type.component';
import { InsuranePeriodComponent } from '../steps/insurane-period/insurane-period.component';
import { PersonalInfoComponent } from '../steps/personal-info/personal-info.component';
import { SuccessPageComponent } from '../steps/success-page/success-page.component';
import { TravelerInfoComponent } from '../steps/traveler-info/traveler-info.component';

@Component({
  selector: 'app-policy',
  templateUrl: './policy.component.html',
  styleUrls: ['./policy.component.scss']
})
export class PolicyComponent implements OnInit {
  private onDispose$: Subject<void> = new Subject<void>();

  constructor(
    public stepService: StepService,
    public activatedRoute: ActivatedRoute,
    private router: Router) {

  }

  ngOnInit(): void {
    this.stepService.steps = [
      InsuranceTypeComponent,
      InsuranceDaysComponent,
      InsuranePeriodComponent,
      PersonalInfoComponent,
      ContactInfoComponent,
      ChoosePolicyComponent,
      AddPassengerComponent,
      AddPassengerFormComponent,
      TravelerInfoComponent,
      FilledInfoComponent,
      SuccessPageComponent
    ];

    if (localStorage.getItem("type") == 'once' && this.stepService.steps.includes(InsuranceDaysComponent)) {
      this.stepService.steps.splice(1, 1);
    }

    if (localStorage.getItem("type") == 'multiple' && this.stepService.steps.includes(InsuranePeriodComponent)) {
      this.stepService.steps = [
        InsuranceTypeComponent,
        InsuranceDaysComponent,
        PersonalInfoComponent,
        ContactInfoComponent,
        ChoosePolicyComponent,
        FilledInfoComponent,
        SuccessPageComponent
      ]
    }

    this.activatedRoute.params.pipe(distinctUntilChanged()).subscribe(params => {
      if (+params.stepNumber > this.stepService.steps.length || +params.stepNumber <= 0) {
        this.stepService.changeStep(1);
      } else {
        this.stepService.changeStep(+params.stepNumber);
      }
    });

    this.stepService.currentStep.pipe(takeUntil(this.onDispose$)).subscribe(step => {
      this.router.navigate(['policy', step]);
    });

  }

  ngOnDestroy() {
    this.onDispose$.next();
    this.onDispose$.complete();
  }
}

